import { getAuthCode } from "./getAuthCode";
export const onboardSites = async(inputs, SetIsError, SetErrorMessage) => {
   const response = await fetch(process.env.REACT_APP_BACKEND_URL +'/onboardingSetup', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ sites: inputs,auth_code:await getAuthCode() }),
      })

    if (!response.ok) {
        SetIsError(true)
        SetErrorMessage('Something went wrong submitting your sites.')
        return
      }
}